(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["toysweetie-fit-guide"] && !Shopify.designMode) return;
  try {
    
  if (!window.toysweetieFitGuideReady) {
    window.toysweetieFitGuideReady = true;

    const finePointer = window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-tsf-open]');

      if (openButton) {
        const dialog = document.getElementById(
          openButton.getAttribute('aria-controls')
        );

        if (dialog && !dialog.open) {
          dialog.showModal();
        }

        return;
      }

      const closeButton = event.target.closest('[data-tsf-close]');

      if (closeButton) {
        const dialog = closeButton.closest('dialog');

        if (dialog) {
          dialog.close();
        }

        return;
      }

      if (event.target.matches('.tsf-dialog')) {
        event.target.close();
      }
    });

    document.addEventListener('pointermove', (event) => {
      if (!finePointer.matches) {
        return;
      }

      const media = event.target.closest('[data-tsf-zoom]');

      if (!media) {
        return;
      }

      const image = media.querySelector('.tsf-size-card__image');
      const lens = media.querySelector('.tsf-magnifier');

      if (!image || !lens || !image.currentSrc) {
        return;
      }

      const mediaRect = media.getBoundingClientRect();
      const imageRect = image.getBoundingClientRect();

      const imageX = event.clientX - imageRect.left;
      const imageY = event.clientY - imageRect.top;

      if (
        imageX < 0 ||
        imageY < 0 ||
        imageX > imageRect.width ||
        imageY > imageRect.height
      ) {
        media.classList.remove('is-zooming');
        return;
      }

      const zoom = parseFloat(media.dataset.zoomLevel) || 2.5;
      const lensRect = lens.getBoundingClientRect();

      const lensX = event.clientX - mediaRect.left;
      const lensY = event.clientY - mediaRect.top;

      lens.style.left = `${lensX}px`;
      lens.style.top = `${lensY}px`;
      lens.style.backgroundImage = `url("${image.currentSrc}")`;
      lens.style.backgroundSize =
        `${imageRect.width * zoom}px ${imageRect.height * zoom}px`;
      lens.style.backgroundPosition =
        `${-(imageX * zoom - lensRect.width / 2)}px ` +
        `${-(imageY * zoom - lensRect.height / 2)}px`;

      media.classList.add('is-zooming');
    });

    document.addEventListener('pointerout', (event) => {
      const media = event.target.closest('[data-tsf-zoom]');

      if (media && !media.contains(event.relatedTarget)) {
        media.classList.remove('is-zooming');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
